var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',{attrs:{"prev-text":"上一页","next-text":"下一页","background":"","layout":"prev, pager, next","page-size":_vm.page.pageSize,"current-page":_vm.page.page,"total":_vm.page.total},on:{"current-change":_vm.currentChange}})}
var staticRenderFns = []

export { render, staticRenderFns }